// frontend/src/utils/auth.js
import AuthService from "../auth/AuthService";

/* ================= AUTH STORAGE ================= */

export function getAuth() {
  return AuthService.getAuth();
}

export function saveAuth(data) {
  return AuthService.saveAuth(data);
}

/* ================= OWNER ================= */

export function getOwnerId() {
  return AuthService.getOwnerId();
}

/* ================= ADMIN ================= */

export function getAdminId() {
  return AuthService.getAdminId();
}

/* ================= ROLE ================= */

export function getUserRole() {
  return AuthService.getRole();
}

/* Where a person starts after signing in when nothing asked them to come back somewhere:
   an admin at the admin desk, a cab owner at My Cars, a hire driver at their driver
   page, anyone else at `fallback`. A page that sent them to sign in (a car, a driver)
   passes redirectTo, and that always wins. */
export function homeForRole(role, fallback = "/") {
  const r = String(role || "").toUpperCase();
  if (r === "ADMIN" || r === "SUPER_ADMIN") return "/admin";
  if (r === "ONBOARDING_AGENT") return "/desk";
  if (r === "OWNER" || r === "CAB_OWNER") return "/owner";
  if (r === "ALTING_DRIVER" || r === "ALT_DRIVER") return "/alting-driver/dashboard";
  return fallback;
}

/* ================= TOKEN ================= */

export function getToken() {
  return AuthService.getToken();
}

export function logout() {
  return AuthService.logout();
}

export function clearLegacyAuth() {
  return AuthService.clearLegacyAuth();
}
